const ATTR_DISABLED = "disabled";

export function showBtnLoading($ele, txt) {
    let otext = jQuery($ele).html();
    return jQuery($ele).html(`<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${txt}`).attr(ATTR_DISABLED, ATTR_DISABLED).data('otext', otext);
}

export function stopBtnLoading($ele) {
    let otext = jQuery($ele).data('otext');
    return jQuery($ele).html(otext).removeAttr(ATTR_DISABLED);
}